import { TextField } from '@mui/material'
import { FormControl, FormHelperText, InputLabel, OutlinedInput } from 'ui'
import { TextMaskPhone } from 'widget'

import { useUserDataForm } from '../../hooks/useUserDataForm'

import style from './ConfirmUserDataForm.module.scss'

type ConfirmUserDataFormProps = ReturnType<typeof useUserDataForm>

export function ConfirmUserDataForm({
  email,
  phone,
  handleEmailChange,
  handleEmailBlur,
  handlePhoneChange,
  handlePhoneBlur,
}: ConfirmUserDataFormProps) {
  return (
    <div className={style.userDataForm}>
      <TextField
        name='email'
        label='Email'
        value={email.value}
        error={email.isError}
        disabled={email.disabled}
        inputProps={{ autoComplete: 'off' }}
        helperText={email.isError ? 'Неверный формат email' : ''}
        data-testid='order-user-email'
        onChange={handleEmailChange}
        onBlur={handleEmailBlur}
      />

      <FormControl>
        <InputLabel
          htmlFor='phone-mask-input'
          className={!phone.isError ? style.label : style.errorLabel}
        >
          Телефон получателя
        </InputLabel>
        <OutlinedInput
          label='Телефон получателя'
          fullWidth
          type='tel'
          name='phone'
          id='phone-mask-input'
          error={phone.isError}
          value={phone.value}
          onChange={handlePhoneChange}
          onBlur={handlePhoneBlur}
          inputProps={{
            inputprops: { min: 18 },
            'data-testid': 'order-user-phone',
          }}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          inputComponent={TextMaskPhone as any}
        />

        {phone.isError ? (
          <span className={style.errorMassage}>Неверный формат телефона</span>
        ) : (
          <FormHelperText id='my-helper-text'>
            Заказ будет получать другой человек
          </FormHelperText>
        )}
      </FormControl>
    </div>
  )
}
